import React, { memo, useCallback, useMemo } from 'react'
import {
  GoToForgeAction,
  IGoToForgeAction,
  GoToForgeOptions,
  AnyActionType,
  ActionGestureTypes,
  IActionComponentProps,
} from '~core/forge.type'
import { Box } from '@chakra-ui/react'
import { Select } from '~editor/components/Select'
import useDispatch from '~editor/hooks/useDispatch'

interface IProps extends IActionComponentProps {
  action: GoToForgeAction
  actions: AnyActionType[]
  activeActionGesture: ActionGestureTypes
}

export const GoToForgeActionComponent = ({
  action,
  actions,
  activeActionGesture,
  isDisabled,
}: IProps) => {
  const dispatch = useDispatch()

  const optionValue = useMemo(() => {
    return GoToForgeOptions.find((option) => action.value === option.value)
  }, [action.value])

  const updateAction = useCallback(
    (value: IGoToForgeAction['value']) => {
      dispatch.nodes.updateActions({
        actionGestureType: activeActionGesture,
        actions: actions.map((_a: AnyActionType) => {
          const _action = { ..._a } as GoToForgeAction
          if (action.id === _action.id) {
            _action.value = value
          }

          return _action
        }),
      })
    },
    [dispatch, activeActionGesture, actions],
  )

  return (
    <Box width="100%">
      <Select
        value={optionValue}
        width="100%"
        height="32px"
        isDisabled={isDisabled}
        options={GoToForgeOptions}
        onChange={(option) => {
          if (option) {
            updateAction((option as any)?.value as IGoToForgeAction['value'])
          }
        }}
      />
    </Box>
  )
}

export default memo(GoToForgeActionComponent)
